import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import WeddingSeo from '@/components/feature/WeddingSeo'
import WeddingIntroSection from '@/components/feature/sections/WeddingIntroSection'
import WeddingTimelineSection from '@/components/feature/sections/WeddingTimelineSection'
import PackagesSection from '@/components/feature/sections/PackagesSection'
import GallerySection from '@/components/feature/sections/GallerySection'
import FaqSection from '@/components/feature/sections/FaqSection'
import WeddingTestimonialsSection from '@/components/feature/sections/WeddingTestimonialsSection'
import CtaBand from '@/components/feature/CtaBand'
import {
  weddingPackages,
  weddingGalleryItems,
  weddingGalleryCategories,
  weddingFaqIds,
} from '@/mocks/wedding'

export default function Wedding() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <WeddingSeo />
      <PageHeader
        breadcrumb={t('pages.wedding.breadcrumb')}
        label={t('pages.wedding.label')}
        title={t('pages.wedding.title')}
        description={t('pages.wedding.description')}
        image="https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20wedding%20mandapam%20with%20the%20bride%20and%20groom%20in%20traditional%20attire%2C%20marigold%20and%20jasmine%20floral%20decor%2C%20warm%20golden%20lighting%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=1920&height=900&seq=shabi-hdr-wedding&orientation=landscape"
        imageAlt="Traditional South Indian wedding ceremony photographed by Shabi Media"
      />
      <WeddingIntroSection />
      <WeddingTimelineSection />
      <PackagesSection packages={weddingPackages} namespace="wedding.packages" whatsappEnquire />
      <GallerySection
        items={weddingGalleryItems}
        categories={weddingGalleryCategories}
        namespace="wedding.gallery"
        showFooter={false}
      />
      <FaqSection ids={weddingFaqIds} namespace="wedding.faq" />
      <WeddingTestimonialsSection />
      <CtaBand
        eyebrow={t('wedding.cta.eyebrow')}
        title={t('wedding.cta.title')}
        description={t('wedding.cta.description')}
      />
    </SiteLayout>
  )
}